export const WHATSAPP_NUMBER = "5561999655654";
export const PHONE_DISPLAY = "(61) 99965-5654";
export const STORE_ADDRESS = "EQNP 11/7, Bloco G, Loja 6 — P. Norte";
export const STORE_CITY = "Ceilândia — DF";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const imageUrl = (img) =>
  img && img.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${img}` : img;
